import { useOrganization } from '@/contexts/OrganizationContext';
import { trpc } from '@/lib/trpc';

const ORDER_STALE_TIME_MS = 30_000;

/**
 * BLU-576: fetch a single purchase order by id, org-scoped and
 * location-independent. Unlike useOrderQueries (a location-scoped,
 * default-limited list), this always resolves the PO regardless of the
 * selected location — used by OrderDetail so opening a PO works in
 * "All Locations".
 */
export function useOrderQuery(orderId: string | undefined) {
  const { organization } = useOrganization();

  const {
    data,
    isLoading: loading,
    isFetching,
    error,
    refetch,
  } = trpc.purchaseOrders.getOrder.useQuery(
    { orderId: orderId ?? '' },
    {
      enabled: !!organization && !!orderId,
      staleTime: ORDER_STALE_TIME_MS,
      retry: 2,
    }
  );

  return {
    order: data?.data ?? null,
    loading: loading || !organization,
    isFetching,
    error,
    refetchOrder: refetch,
  };
}
